import { autoCapitalize } from '@/utils/autoCapitalize'

class PatientHistoryMapper {
  toDomain(persistenceData) {
    return {
      registerDate: persistenceData?.dataCadastro,
      registerMethod: autoCapitalize(persistenceData?.tipoCriacao),
      registerResponsible: persistenceData?.nomeUsuarioRespCriacao,
      activationDate: persistenceData?.dataHoraAtivacao,
      termAccepted: persistenceData?.flagTermoAceito ? 'Sim' : 'Não',
      termAcceptDate: persistenceData?.dataHoraTermoAceito,
      blocked: persistenceData?.flagBloqueado ? 'Sim' : 'Não',
      blockDate: persistenceData?.dataHoraBloqueio,
      blockResponsible: autoCapitalize(
        persistenceData?.responsavelPeloBloqueio,
      ),
      lastBlockDate: persistenceData?.dataUltimoBloqueio,
      unblockDate: persistenceData?.dataDesbloqueio,
      unblockResponsible: persistenceData?.getResponsavelPeloDesbloqueio,
    }
  }
}

export default new PatientHistoryMapper()
